import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function kpiCardBodyTrend(theme: Theme): ComponentStyle {
  return {
    componentName: 'kpiCardBodyTrend',
    variants: {
      sharedTitle: {
        fontSize: theme.sizes[1]
      },
      singleTitle: {
        fontSize: theme.sizes[2]
      }
    }
  };
}
